/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_CancelledInputs */

const en_subscription_cancelled = /** @type {(inputs: Subscription_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelled`)
};

const fr_subscription_cancelled = /** @type {(inputs: Subscription_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annulé`)
};

const de_subscription_cancelled = /** @type {(inputs: Subscription_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abgesagt`)
};

const it_subscription_cancelled = /** @type {(inputs: Subscription_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annullato`)
};

const ru_subscription_cancelled = /** @type {(inputs: Subscription_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отменено`)
};

const es_subscription_cancelled = /** @type {(inputs: Subscription_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelado`)
};

const zh_cn2_subscription_cancelled = /** @type {(inputs: Subscription_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`取消`)
};

const ja_subscription_cancelled = /** @type {(inputs: Subscription_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キャンセル`)
};

const hi_subscription_cancelled = /** @type {(inputs: Subscription_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रद्द कर दिया गया`)
};

const pt_pt2_subscription_cancelled = /** @type {(inputs: Subscription_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelado`)
};

/**
* | output |
* | --- |
* | "Cancelled" |
*
* @param {Subscription_CancelledInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subscription_cancelled = /** @type {((inputs?: Subscription_CancelledInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_CancelledInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subscription_cancelled(inputs)
	if (locale === "de") return de_subscription_cancelled(inputs)
	if (locale === "it") return it_subscription_cancelled(inputs)
	if (locale === "ru") return ru_subscription_cancelled(inputs)
	if (locale === "es") return es_subscription_cancelled(inputs)
	if (locale === "zh-CN") return zh_cn2_subscription_cancelled(inputs)
	if (locale === "ja") return ja_subscription_cancelled(inputs)
	if (locale === "hi") return hi_subscription_cancelled(inputs)
	if (locale === "pt-PT") return pt_pt2_subscription_cancelled(inputs)
	return en_subscription_cancelled(inputs)
});